export const environment = {
  production: "false",
  adfsAuthority: "https://auth.alliedpilots.org/adfs/",
  myTripUrl: "https://mytripservice.alliedpilots.org/",
  apimSubscriptionKey: "b4e3dd5b0e78408382bb347d2d0c32f2",

  seqHistClientId: "https://sequencehistory.alliedpilots.org",
  seqHistApimUrl: "https://apagateway.alliedpilots.org/sequencehistoryservice",

  memberInfoUrl: "https://apagateway.alliedpilots.org/memberinfoservice/api/Membership/LookupDetails",
};
